import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_ctx.allClients.length === 0)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: "/assets/empty-clients.svg",
                "max-width": "150"
              })
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-center mt-2" }, [
            _createElementVNode("span", null, "No clients available")
          ], -1))
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_card, {
        key: 1,
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi-account-group" }),
              _cache[3] || (_cache[3] = _createTextVNode("   Clients ")),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                density: "compact",
                label: "Search",
                "prepend-inner-icon": "mdi-magnify",
                variant: "solo-filled",
                flat: "",
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_data_table, {
            search: _ctx.search,
            "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            items: _ctx.allClients,
            headers: _ctx.headers
          }, {
            "item.name": _withCtx(({ item }) => [
              _createVNode(_component_router_link, {
                to: `/clients/${item.clientId}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            "no-data": _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "custom-no-data" }, " No clients found. ", -1)
            ])),
            "header.active": _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "text-end" }, "Status", -1)
            ])),
            "item.image": _withCtx(({ item }) => [
              _createVNode(_component_v_card, {
                class: "my-2",
                elevation: "2",
                rounded: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: `https://cdn.vuetifyjs.com/docs/images/graphics/gpus/${item.image}`,
                    height: "64",
                    cover: ""
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024)
            ]),
            "item.objectives": _withCtx(({ item }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.objectives, (objective, index) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: index,
                  class: "ma-1",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("  " + _toDisplayString(objective), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            "item.progress": _withCtx(({ item }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.progress, (opacity, index) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: index,
                  style: _normalizeStyle({ opacity: opacity / 5}),
                  class: "ma-2",
                  color: "primary",
                  variant: "flat",
                  label: ""
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("   ")
                  ])),
                  _: 2
                }, 1032, ["style"]))
              }), 128))
            ]),
            "item.active": _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_chip, {
                  color: item.active ? 'green' : 'red',
                  text: item.active ? 'Active' : 'Not active',
                  class: "text-uppercase",
                  size: "small",
                  label: ""
                }, null, 8, ["color", "text"])
              ])
            ]),
            _: 1
          }, 8, ["search", "items", "headers"])
        ]),
        _: 1
      }))
}